<template>
  <q-dialog
    v-model="shown"
    full-height
    maximized
    :position="$q.screen.gt.xs ? 'right' : undefined"
    :transition-show="$q.screen.gt.xs ? 'slide-left' : 'slide-up'"
    :transition-hide="$q.screen.gt.xs ? 'slide-right' : 'slide-down'"
    class="q-pa-none"
    data-test-id="drawer-dialog"
  >
    <q-card
      class="full-height column"
      :style="{ 'width': $q.screen.gt.xs ? '500px' : undefined }"
    >
      <q-bar class="bg-transparent col-auto">
        <q-space />

        <q-btn
          v-close-popup
          padding="sm"
          dense
          flat
          icon="close"
          size="md"
          rounded
          @click="shown = false"
        >
          <q-tooltip class="bg-white text-primary">
            Close
          </q-tooltip>
        </q-btn>
      </q-bar>
      <q-scroll-area class="col">
        <slot name="content" />
      </q-scroll-area>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'DrawerDialog',
  emits: ['shown'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    shown () {
      this.$emit('shown', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    }
  }
}
</script>
